import { Box } from "@chakra-ui/react";
import CaseHistoryCard from "./CaseHistory/CaseHistoryCard";

const CaseHistorySection = ({ key, data }) => {
  return (
    <Box>
      <CaseHistoryCard info={data} />
    </Box>
  );
};

export default CaseHistorySection;
